import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import "./styles.css";

if (navigator.userAgent.includes("JTUC-Live-Mobile/")) {
  document.documentElement.classList.add("jtuc-native-mobile");
  const viewport = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  viewport?.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover");
}

let reloadingForServiceWorker = false;
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadingForServiceWorker) return;
    reloadingForServiceWorker = true;
    window.location.reload();
  });
}

const updateServiceWorker = registerSW({
  immediate: true,
  onNeedRefresh() { void updateServiceWorker(true); },
  onRegisteredSW(_url, registration) {
    window.setInterval(() => { void registration?.update(); }, 60 * 60 * 1000);
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("Root element is missing");
createRoot(root).render(<StrictMode><App /></StrictMode>);
